import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  form: {
    '& > div': {
      width: '100%',
      marginBottom: '32px',
    },
  },
  emailLabel: {
    fontSize: theme.variables.fontSizeSm,
  },
  heplerText: {
    fontSize: theme.variables.fontSizeMd,
    color: '#202833',
    marginTop: 0,
    marginBottom: '16px',
  },
  mainTitle: {
    textAlign: 'left',
    marginBottom: '6px',
    fontSize: theme.variables.fontSizeLg,
  },
  container: ({ height }: { height?: number | string }) => ({
    position: 'static',

    '& .MuiPaper-root': {
      justifyContent: 'space-between',
      borderRadius: '16px',
      width: '354px',
      minHeight: height ? height : '272px',
      padding: '32px',
      margin: 0,
    },
  }),
}))

export default useStyles
